import { render, staticRenderFns } from "./AgentQuestions.vue?vue&type=template&id=bcc88582&"
import script from "./AgentQuestions.vue?vue&type=script&lang=js&"
export * from "./AgentQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports